import { ApiResponse, ApiService } from './../../../providers/api.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { Subscription } from 'rxjs';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';

@Component({
  selector: 'sm-add-edit-tax-gst',
  templateUrl: './add-edit-tax-gst.component.html',
  styleUrls: ['./add-edit-tax-gst.component.scss']
})
export class AddEditTaxGstComponent implements OnInit {
  private _apiSubscription: Subscription = new Subscription();
  taxObj: any = {
    tanNumber: null,
    panNumber: null,
    gstStatus: 0,
    cgstStatus: 0,
    igstStatus:  0,
    sgstStatus: 0,
    utgstStatus: 0,
    serviceTaxStatus: 0,
    otherTaxStatus:  0,
    gstNumber: null,
    sgstValue: null,
    cgstValue: null,
    igstValue: null,
    utgstValue: null,
    otherTax: null,
    otherTaxName: null,
    serviceTaxValue: 0
  }

  public mainTaxList: any = [
    {
      id: 1,
      title: 'GST Status',
      toggled: 0
    },
    {
      id: 2,
      title: 'Service Tax',
      toggled: 0
    },
    {
      id: 3,
      title: 'Other tax',
      toggled: 0
    }
  ]

  public gstList: any = [
    {
      id: 1,
      mapId: 1,
      title: 'CGST',
      toggled: 0
    },
    {
      id: 2,
      mapId: 1,
      title: 'IGST',
      toggled: 0
    },
    {
      id: 3,
      mapId: 1,
      title: 'SGST',
      toggled: 0
    },
    {
      id: 1,
      mapId: 1,
      title: 'UTGST',
      toggled: 0
    }
  ]

  constructor(@Inject(MAT_DIALOG_DATA) public parentData: any, private _apiservice: ApiService, private loaderservice: LoaderServiceService) { }

  ngOnInit(): void {

    let data = this.parentData.data

    this.taxObj.tanNumber = data.tanNumber
    this.taxObj.panNumber = data.panNumber
    this.taxObj.gstStatus = data.gstStatus ? data.gstStatus : 0
    this.taxObj.cgstStatus = data.cgstStatus ? data.cgstStatus : 0
    this.taxObj.igstStatus = data.igstStatus ? data.igstStatus : 0
    this.taxObj.sgstStatus = data.sgstStatus ? data.sgstStatus : 0
    this.taxObj.utgstStatus = data.utgstStatus ? data.utgstStatus : 0
    this.taxObj.serviceTaxStatus = data.serviceTaxStatus ? data.serviceTaxStatus : 0
    this.taxObj.otherTaxStatus = data.otherTaxStatus ? data.otherTaxStatus : 0
    this.taxObj.gstNumber = data.gstNumber
    this.taxObj.sgstValue = data.sgstValue
    this.taxObj.cgstValue = data.cgstValue
    this.taxObj.igstValue = data.igstValue
    this.taxObj.utgstValue = data.utgstValue
    this.taxObj.otherTax = data.otherTax
    this.taxObj.otherTaxName = data.otherTaxName
    this.taxObj.serviceTaxValue = data.serviceTaxValue

    console.log(this.taxObj);
    

    this._apiSubscription = this._apiservice.apiResult.subscribe((resData) => {
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_TAX_DATA){

        this.parentData.ref.closeAll();
      }
    })
  }

  onToggleChange(event:any){
    
    if(event.checked){
      this.taxObj.gstStatus = 1
    }else if(!event.checked){
      this.taxObj.gstStatus = 0

    }
  }
  onToggleChangeCGST(event:any){
    if(event.checked){
      this.taxObj.cgstStatus = 1
    }else if(!event.checked){
      this.taxObj.cgstStatus = 0
    }
  }
  onToggleChangeIGST(event:any){
    
    if(event.checked){
      this.taxObj.igstStatus = 1
    }else if(!event.checked){
      this.taxObj.igstStatus = 0
      
    }
  }
  onToggleChangeSGST(event:any){
    
    if(event.checked){
      this.taxObj.sgstStatus = 1
    }else if(!event.checked){
      this.taxObj.sgstStatus = 0
    }
  }
  onToggleChangeUTGST(event:any){
    
    if(event.checked){
      this.taxObj.utgstStatus = 1
    }else if(!event.checked){
      this.taxObj.utgstStatus = 0
    }
  }
  onToggleChangeServiceTax(event:any){
    
    if(event.checked){
      this.taxObj.serviceTaxStatus = 1
    }else if(!event.checked){
      this.taxObj.serviceTaxStatus = 0
      
    }
  }
  onToggleChangeOtherTax(event:any){
    
    if(event.checked){
      this.taxObj.otherTaxStatus = 1
    }else if(!event.checked){
      this.taxObj.otherTaxStatus = 0

      
    }
  }

  onSubmitTaxDetails(){

    let data = JSON.parse(JSON.stringify(this.taxObj))

    data.createdBy = data.editedBy = localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
    data.businessHashId = this.parentData.data.businessHashId
    Object.keys(data).forEach(key => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });
    console.log(this.taxObj);
    console.log(data);
    this.loaderservice.showLoader = true
    this._apiservice.addEditEntityTaxData(data)
  }

}
